import React, { Component } from 'react';

class ProcessThreeSteps extends Component {
  render(){
    return(
    <div className="container extra-padding-bottom">
      <div className="wrap">
         <div className="block block-wrap">
            <div className="block-title-container">
             <h5 className="block-title">{this.props.heading}</h5>
            </div>
            <div className="col col-1 col-1-2--m col-1-3--l">
              <h2 className="step-number" style={{marginTop: 0}}>01</h2>
              <h3 className="slogan">{this.props.first}</h3>
              <p>{this.props.firstDetail}</p>
            </div>
            <div className="col col-1 col-1-2--m col-1-3--l">
              <h2 className="step-number">02</h2>
              <h3 className="slogan">{this.props.second}</h3>
                <p>{this.props.secondDetail}</p>
            </div>
            <div className="col col-1 col-1-3--l">
              <h2 className="step-number">03</h2>
              <h3 className="slogan">{this.props.third}</h3>
                <p>{this.props.thirdDetail}</p>
            </div>
           </div>
      </div>
    </div>);
  }
}

export default ProcessThreeSteps;



// WEBPACK FOOTER //
// ./src/layout/Process.js